import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL, setSession, clearSession } from '../auth/authMode';

/**
 * Platform SSO callback: exchanges one-time ZSaaS token for HR session via backend.
 * Does not trust role/userDetails from the query string.
 */
const SsoCallback = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        const ssoToken = params.get('token') || params.get('ssoToken');
        if (!ssoToken) {
            setError('Missing SSO token');
            return;
        }

        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/auth/sso/exchange`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ssoToken }),
                });
                const data = await res.json().catch(() => ({}));
                if (!res.ok) {
                    throw new Error(data.error || 'SSO exchange failed');
                }
                if (cancelled) return;
                setSession(data.token, data.user);
                navigate('/dashboard', { replace: true });
            } catch (err) {
                clearSession();
                if (!cancelled) setError(err.message || 'SSO failed');
            }
        })();

        return () => { cancelled = true; };
    }, [params, navigate]);

    if (error) {
        return (
            <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
                <h1>SSO failed</h1>
                <p style={{ color: '#b91c1c' }}>{error}</p>
                <a href="/login">Back</a>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
            <h1>Completing sign-in…</h1>
        </div>
    );
};

export default SsoCallback;
